import { useEffect, useState, useRef } from 'react'
import { userSelector } from 'auth/selectors'
import { sendFeedback } from 'wordpress/actions'
import { pendingFeedbackSelector } from 'wordpress/selectors'
import { Image } from 'wordpress/components'
import { ContactForm, Message } from '@components/ContactForm'
import Button from '@components/Button'

import './Contact.scss'

const ConfirmationMessage = () => (
    <div className="container-fluid p-0 confirmation-message">
        <h2>
            <T>feedback.success.title</T>
        </h2>
        <div>
            <T>feedback.success.message</T>
        </div>
    </div>
)

const Contact = ({
    background,
    buttonLabel,
    contactPurposes: categories = [{ label: 'General' }],
    pending,
    contactPhone = null,
    showCallRate = true,
    showEmailField = false,
    error,
    sendFeedback,
    name,
    email,
    translate,
}) => {
    const [sent, setSent] = useState(false)
    const formRef = useRef()

    useEffect(() => {
        if (pending && !error && !sent) {
            setSent(true)
        } else if (pending && error) {
            setSent(false)
        } else if (!pending && !error && sent) {
            if (formRef && formRef.current) formRef.current.resetForm()
        }
    }, [pending, error, sent])

    const submitForm = data => {
        const labels = {
            name: translate('feedback.name.label'),
            email: translate('feedback.email.label'),
        }

        Object.keys(data).forEach(key => {
            labels[key] = translate(`feedback.${key}.label`)
        })

        if (!pending) {
            sendFeedback({ email, ...data, name, labels })
        }
    }

    return (
        <div className="contact-us">
            <Image className="img-container" image={background} background />
            <div className="contact-form">
                <ContactForm onSubmit={submitForm} error={error} ref={formRef}>
                    <h2>
                        <span>
                            <T>feedback.mail.us.label</T>
                            <hr />
                        </span>
                    </h2>
                    <Message categories={categories} showEmailField={showEmailField} showTitle={false} />
                    <Button btnStyle="outline-invert" type="submit" isLoading={pending === true}>
                        {buttonLabel || <T>dashboard.label.contact.send</T>}
                    </Button>
                </ContactForm>
                {sent && !pending && !error && <ConfirmationMessage />}
            </div>
            <div className="call-us">
                <h2>
                    <T>dashboard.call.us.label</T>
                </h2>
                <p className="phone-nr">{contactPhone || <T>dashboard.call.us.phone.no</T>}</p>
                {showCallRate && (
                    <p className="phone-tarif">
                        <T>dashboard.call.us.rate</T>
                    </p>
                )}
            </div>
        </div>
    )
}

const mapStateToProps = createSelector(pendingFeedbackSelector, userSelector, (pendingState, userState) => ({
    ...pendingState,
    ...userState,
}))
export default compose(withTranslate, connect(mapStateToProps, { sendFeedback }))(Contact)
